import { render } from "./ITextFieldEditable.vue?vue&type=template&id=88f2953a&scoped=true"
import script from "./ITextFieldEditable.vue?vue&type=script&lang=js"
export * from "./ITextFieldEditable.vue?vue&type=script&lang=js"

import "./ITextFieldEditable.vue?vue&type=style&index=0&id=88f2953a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f2953a"]])

export default __exports__